import React from 'react';
import  './css/Accion.css';

export default class Accion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render(){
    const {backgroundColor, disabled, icono, ayuda, onClick, tamaño} = this.props;
    return(
      <span
        className="material-icons Accion"
        style={{
          fontSize: tamaño ? tamaño : null,
          backgroundColor: backgroundColor,
          color: disabled ? "grey" : "black",
          cursor: disabled ? "not-allowed" : "pointer"
        }}
        onClick={() => !disabled && onClick()}
        title={ayuda}
      > {icono} </span>
    )
  }
}

/*
import {Accion} from '../comun/Index';

<Accion
  icono=""
  ayuda=""
  backgroundColor="#"
  disabled={false}
  onClick={() => funcion()}
/>
*/
